import { CSSProperties } from "react";
import FontWeight from '../../../../../../constants/FontWeight';

export default class InfoDialogSubtitleViewStyle {

    subtitle : CSSProperties = {
        fontFamily : 'Asap',
        fontWeight : FontWeight.MEDIUM,
        fontSize : 28,
        color : '#fff',
        marginBottom : 20
    }
}